var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-loading"},[_c('div',{staticClass:"primary"},[_c('p',{staticClass:"title"},[_vm._v("没有找到相关宝贝")]),_c('Button',{staticClass:"my_btn mr_20",attrs:{"type":"primary","ghost":""},on:{"click":_vm.goBack}},[_vm._v("返回")]),_c('Button',{staticClass:"my_btn",attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }